import { IdentityOptions } from '../types/internal-types';

export class LogHelper {
  static options?: IdentityOptions;

  private static readonly prefix:string = 'PEAK-IDENTITY';

  static log(...args: unknown[]):boolean {
    if (!this.options?.debugMode) { return false; }

    console.group(this.prefix, 'TOKEN UPDATE');

    console.log(...args);

    console.groupEnd();

    return true;
  }

  static error(...args: unknown[]):boolean {
    if (!this.options?.debugMode) { return false; }

    console.group(this.prefix, 'EXCEPTION');

    console.error(...args);

    console.groupEnd();

    return true;
  }
}
